import bigcommerceGenericDefaults from '../bigcommerce-generic/config.js';

const categorySelectionPageUrl = '/categories/';
var baseFitmentFields = ['RideCategory', 'RideType', 'Year', 'Make', 'Model'];
var extraFitmentFields = ['Submodel'];

export default {
  includes: ['bigcommerce-generic'],
  ...bigcommerceGenericDefaults,
  fitmentSearch: {
    ...bigcommerceGenericDefaults.fitmentSearch,
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
  },
  Widgets: [
    ...bigcommerceGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'HomeVehicleWidget_tab',
          'SearchBox',
          'Garage',
          'VerifyFitment',
          'FitmentTable',
          'CategoryPage',
          'CategoryFacetPanel',
          'FacetCategoryTiles',
        ].includes(w.name),
    ),
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: {
        lastChildOf: '[data-content-region="home_below_carousel"]',
        class: 'container',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 1000,
    },
    {
      name: 'SearchBox',
      location: {
        replace: 'form[data-quick-search-form]',
        class: 'search search-modal__form',
      },
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxMobile',
      type: 'SearchBoxDialogButton',
      location: '.navPages-quickSearch .container',
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '.navUser-item--cart',
        wrapper: 'li',
        class: 'navUser-item cm_garage_container',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'CategoryFacetPanel',
      type: 'SearchPage',
      location: {
        replace: '#faceted-search-container',
        class: 'cm_FacetPanel__category',
      },
      template: 'FacetPanelContainer',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: { replace: '#product-listing-container', class: 'cm_main-content' },
      template: 'MainContent',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '.body .page',
      template: 'facetTiles/hierarchicalContainer',
      visibleIf: () => window.location.pathname === categorySelectionPageUrl,
    },
    {
      name: 'VerifyFitment',
      location: { insertBefore: '.productView-details .productView-options' },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTable',
      location: {
        lastChildOf: '.tabs-contents',
        class: 'tab-content',
        id: 'tab-fitment',
      },
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: { lastChildOf: '.productView-description ul', wrapper: 'li', class: 'tab' },
      template: 'fitmentSearch/fitmentTableTab',
    },
  ],
};
